<template>
    <div class="flex grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2">
            <pca-card-form
                :meta="printContractMeta"
                :use-default-buttons="true"
                components-path="views/contracts/print-contract/components"
                :callbacks="{ refreshData: refreshPrintContract, saveData: savePrintContract, isDirty: null }"
            />
        </div>
    </div>
</template>

<script>
import { defineProps, ref } from 'vue';
import printContractMeta from '@/views/contracts/print-contract/print-contract-meta';

import UiNotify from 'devextreme/ui/notify';

import PcaCardForm from '@/views/contracts/print-contract/components/pca-card-form.vue';

export default {
    computed: {
        printContractMeta() {
            return printContractMeta;
        },
    },
    components: {
        PcaCardForm,
    },
    data() {
        return {};
    },

    setup(/*props*/) {
        const contractEntitySelection = ref(2);

        const mustBePrintedContract = ref(true);
        const mustBePrintedAnnexes = ref(false);
        const mustBePrintedStandardLetters = ref(false);
        const mustBePrintedClaims = ref(false);

        const printWithMaximumPowerZero = ref(false);
        const printWithConstantConsumption = ref(false);

        const printInOneFile = ref(true);
        const replaceExistingFile = ref(false);
        const generateInPdf = ref(false);

        const codeLocationPrintedFiles = ref('');

        const selectedContractSigned = ref(1);
        const selectedAnnexForm = ref(1);
        const selectedPrintWhere = ref(1);
        const selectedSettingMeteringPoint = ref(1);

        const contractValue = ref([2000286423]);
        const isContractOpened = ref(false);

        const listContractValue = ref([2000286423]);

        const contractIntervalFromValue = ref('');
        const contractIntervalToValue = ref('');

        const contractStatusValue = ref([]);
        const isContractStatusOpened = ref(false);

        const contractTypeValue = ref([]);
        const isContractTypeOpened = ref(false);

        const responsibleForContractValue = ref([]);
        const isResponsibleForContractOpened = ref(false);

        const asOfDate = ref(new Date());

        const listObjectValue = ref([2000477092]);

        const objectStatusValue = ref([]);
        const isObjectStatusOpened = ref(false);

        const listAnnexValue = ref([4]);

        const subdivisionValue = ref([]);
        const isSubdivisionOpened = ref(false);

        const meteringPointStatusValue = ref([]);
        const isMeteringPointStatusesOpened = ref(false);

        const listMeteringPointValue = ref([316370]);

        const meteringPointCreationDate = ref(null);
        const meteringPointDeletionDate = ref(null);
        const electricityMeterInstallationDate = ref(null);
        const electricityMeterRemovalDate = ref(null);

        const signerValue = ref([1]);
        const isSignersOpened = ref(false);

        const collapsed = ref(false);

        const changeContract = (/*e*/) => {
            isContractOpened.value = false;
        };
        const changeSubdivision = (/*e*/) => {
            isSubdivisionOpened.value = false;
        };
        const changeContractStatus = (/*e*/) => {
            isContractStatusOpened.value = false;
        };
        const changeContractType = (/*e*/) => {
            isContractTypeOpened.value = false;
        };
        const changeResponsibleForContract = (/*e*/) => {
            isResponsibleForContractOpened.value = false;
        };
        const changeObjectStatus = (/*e*/) => {
            isObjectStatusOpened.value = false;
        };
        const changeMeteringPointStatus = (/*e*/) => {
            isMeteringPointStatusesOpened.value = false;
        };
        const changeContractSigned = e => {
            selectedContractSigned.value = e.value;
        };
        const changeAnnexForm = e => {
            selectedAnnexForm.value = e.value;
        };
        const changePrintWhere = e => {
            selectedPrintWhere.value = e.value;
        };
        const changeSigner = (/*e*/) => {
            isSignersOpened.value = false;
        };
        const changeSettingMeteringPoint = e => {
            selectedSettingMeteringPoint.value = e.value;
        };

        const collapseToggle = () => {
            collapsed.value = !collapsed.value;
        };

        const viewButton = {
            text: '...',
            stylingMode: 'text',
            onClick: () => {
                //passwordMode.value = passwordMode.value === 'text' ? 'password' : 'text';
            },
        };

        const getComponents = group => {
            return printContractMeta.components.filter(item => item.groupId === group.id);
        };

        const notifyErrorMessage = message => {
            UiNotify({
                message: message,
                type: 'error',
                closeOnClick: true, // This option allows the notification to be closed when clicked
            });
        };

        const refreshPrintContract = async () => {
            return {
                result: true,
                data: {
                    contract_entity_selection_text: 'Список договоров',
                    contract_entity_selection_id: 1,

                    contract_value: 14,
                    contract_number: '122 Э',

                    list_contract_value: [],
                    list_contract_number: '',

                    list_type_contract_value: [],
                    list_type_contract_name: '',

                    contract_status_text: 'Активные и Новые',
                    contract_status_value: '0,2',

                    as_of_date: new Date(),

                    object_entity_selection_text: 'Список объектов',
                    object_entity_selection_id: 1,

                    list_object_value: [],
                    list_object_number: '',

                    object_status_text: 'Активные и Новые',
                    object_status_value: '0,2',

                    metering_point_entity_selection_text: 'По состоянию на дату печати',
                    metering_point_entity_selection_id: 1,

                    metering_point_status_text: 'Активные и Новые',
                    metering_point_status_value: '0,2',

                    metering_point_creation_date: new Date(),
                    metering_point_deletion_date: new Date(),
                    electricity_meter_installation_date: new Date(),
                    electricity_meter_removal_date: new Date(),

                    print_with_maximum_power_zero: true,
                    print_with_constant_consumption: true,

                    list_metering_point_value: [],
                    list_metering_point_number: '',

                    // элементы раздела Что печатать
                    must_be_printed_contract: true,
                    must_be_printed_annexes: true,
                    must_be_printed_standard_letters: false,
                    must_be_printed_claims: false,

                    list_annex_value: [],
                    list_annex_name: '',

                    contract_signed_entity_selection_text: 'Сотрудник',
                    contract_signed_entity_selection_id: 1,

                    contract_signed_value: 14,
                    contract_signed_number: '122 Э',

                    annex_form_entity_selection_text: 'Полная',
                    annex_form_entity_selection_id: 1,

                    print_where_entity_selection_text: 'В файловой системе',
                    print_where_entity_selection_id: 1,

                    print_in_one_file: true,
                    replace_existing_file: false,
                    generate_in_pdf: false,
                },
            };
        };

        const savePrintContract = async () => {
            return await null;
        };

        const props = defineProps({
            // метаданные для карточки
            meta: {
                type: Object,
                default: () => {},
            },
            // путь до всех компонентов оберток, надо указать от view и до последней директории
            componentsPath: {
                type: String,
                default: 'components',
            },
            // расширение тулбара кастомными элементами
            toolbarItems: {
                type: Array,
                default: () => [],
            },
            // вкл/выкл стандартных кнопок (пока две: обновить и сохранить)
            useDefaultButtons: {
                type: Boolean,
                default: true,
            },
            // использовать когда стандартное поведение надо переопределить
            defaultHandlers: {
                type: Object,
                default: () => ({ refresh: null, commit: null }),
            },
            // использовать для подключения бэка к стандартному поведению
            callbacks: {
                type: Object,
                default: () => ({
                    refreshData: null,
                    saveData: null,
                    isDirty: null,
                    sendUserData: null,
                    getUserData: null,
                }),
            },
        });

        return {
            asOfDate,

            contractEntitySelection,

            mustBePrintedContract,
            mustBePrintedAnnexes,
            mustBePrintedStandardLetters,
            mustBePrintedClaims,

            meteringPointCreationDate,
            meteringPointDeletionDate,
            electricityMeterInstallationDate,
            electricityMeterRemovalDate,
            printWithMaximumPowerZero,
            printWithConstantConsumption,

            printInOneFile,
            replaceExistingFile,
            generateInPdf,

            codeLocationPrintedFiles,

            selectedContractSigned,
            selectedAnnexForm,
            selectedPrintWhere,
            selectedSettingMeteringPoint,

            contractValue,
            listContractValue,
            contractIntervalFromValue,
            contractIntervalToValue,
            contractStatusValue,
            contractTypeValue,
            responsibleForContractValue,
            subdivisionValue,
            objectStatusValue,
            meteringPointStatusValue,
            listMeteringPointValue,
            listObjectValue,
            listAnnexValue,
            signerValue,

            isContractOpened,
            isSubdivisionOpened,
            isContractStatusOpened,
            isContractTypeOpened,
            isResponsibleForContractOpened,
            isObjectStatusOpened,
            isMeteringPointStatusesOpened,
            isSignersOpened,

            collapsed,

            viewButton,

            changeContract,
            changeContractSigned,
            changeSubdivision,
            changeContractStatus,
            changeContractType,
            changeResponsibleForContract,
            changeObjectStatus,
            changeAnnexForm,
            changePrintWhere,
            changeSigner,
            changeSettingMeteringPoint,
            changeMeteringPointStatus,

            collapseToggle,

            getComponents,
            notifyErrorMessage,
            refreshPrintContract,
            savePrintContract,
            props,
        };
    },

    methods: {},
};
</script>

<style></style>
